import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./slices/adminSlice";
import collectionsReducer from "./slices/collectionsSlice";
import brandsShowcaseReducer from "./slices/brandsShowcaseSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    collections: collectionsReducer,
    brandsShowcase: brandsShowcaseReducer,
  },
});

export default store;
